import { useWindowSize } from '~Hooks';

export const useIsLandscape = () => {
  const { width, height } = useWindowSize();

  return width > height;
};
